module.exports = __webpack_public_path__ + "img/Logos_Ajuntaments_260x260-CO.e7845be0.png";